import { Routes, Route } from "react-router-dom";
import Dashboard from "./Frontend/Pages/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "./Store/slices/cartSlice";
import AppLayout from "./Frontend/Layout/AppLayout";
import { message } from "antd";
import { useEffect, useState } from "react";
import AddProducts from "./Frontend/Products/AddProducts";
import GetProducts from "./Frontend/Products/GetProducts";
import UpdateProducts from "./Frontend/Products/UpdateProducts";
import TableOrder from "./Frontend/Orders/TableOrder";
import InfoOrder from "./Frontend/Orders/InfoOrder";
import HomeShop from "./Frontend/Pages/HomeShop";
import CartShop from "./Frontend/Pages/CartShop";
import AddCustomer from "./Frontend/Customer/AddCustomer";
import GetCustomer from "./Frontend/Customer/GetCusomer";
import UpdateCustomer from "./Frontend/Customer/UpdateCustomer";
import Stock from "./Frontend/Products/Stock";
import Reports from "./Frontend/Pages/Reports";
import AddUnit from "./Frontend/Unit/AddUnit";
import GetUnit from "./Frontend/Unit/GetUnit";
import UpdateUnit from "./Frontend/Unit/UpdateUnit";
import NotFound from "./Frontend/Pages/NotFound";
import Payment from "./Frontend/Customer/Payment";
import IncreasePayment from "./Frontend/Customer/IncreasePayment";
import { apiClient } from "./Frontend/Api/AllApi";
import i18 from "./i18";
import CustomerOrderHistory from "./Frontend/Customer/CustomerOrderHistory";
import CustomerOrderDetail from "./Frontend/Customer/CustomerOrderDetail";
import PaymentRecipt from "./Frontend/Customer/PaymentRecipt";
import CustomerPaymentHistory from "./Frontend/Customer/CustomerPaymentHistory";
import EditOrder from "./Frontend/Pages/EditOrder";
import CombinedPayments from "./Frontend/Customer/CombinedPayments";
import GetCategory from "./Frontend/Categories/GetCategory";
import AddCategory from "./Frontend/Categories/AddCategory";
import UpdateCategory from "./Frontend/Categories/UpdateCategory";
import CategoryProductReport from "./Frontend/Pages/CategoryProductReport";

const Home = () => {
  useEffect(() => {
    i18.changeLanguage("en");
  }, []);

  //TODO: GET products
  const [storeProducts, setStoreProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);
  const [customersLoading, setCustomersLoading] = useState(true);
  const [unitsLoading, setUnitsLoading] = useState(true);

  useEffect(() => {
    setProductsLoading(true);
    Promise.all([apiClient.get(`/products`)])
      .then(([productsResponse]) => {
        setStoreProducts(productsResponse.data);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        message.error("Error loading products");
      })
      .finally(() => {
        setProductsLoading(false);
      });
  }, []);

  //TODO: GET customers
  const [storeCustomer, setStoreCustomer] = useState([]);
  useEffect(() => {
    setCustomersLoading(true);
    Promise.all([apiClient.get(`/customers`)])
      .then(([productsResponse]) => {
        setStoreCustomer(productsResponse.data);
      })
      .catch((error) => {
        console.error("Error fetching customers:", error);
        message.error("Error loading customers");
      })
      .finally(() => {
        setCustomersLoading(false);
      });
  }, []);

  //TODO: GET units
  const [storeUnits, setStoreUnits] = useState([]);
  useEffect(() => {
    setUnitsLoading(true);
    Promise.all([apiClient.get(`/units`)])
      .then(([productsResponse]) => {
        setStoreUnits(productsResponse.data);
      })
      .catch((error) => {
        console.error("Error fetching units:", error);
        message.error("Error loading units");
      })
      .finally(() => {
        setUnitsLoading(false);
      });
  }, []);

  //TODO: react redux
  // eslint-disable-next-line no-unused-vars
  const [show, setShow] = useState(true);

  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.items);
  const handleClick = (item) => {
    dispatch(addToCart(item));
    // Notify user about the addition to the cart
    message.success("Add to Card");

    // console.log("", cart);
  };

  return (
    <AppLayout cartCount={cart.length}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/AddProducts" element={<AddProducts />} />
        <Route path="/Stock" element={<Stock />} />
        <Route path="/GetProducts" element={<GetProducts />} />
        <Route
          path="/GetProducts/UpdateProducts/:id"
          element={
            <UpdateProducts
              storeProducts={storeProducts}
              isLoading={productsLoading}
            />
          }
        />
        <Route path="/AddCustomer" element={<AddCustomer />} />
        <Route path="/GetCustomer" element={<GetCustomer />} />
        <Route
          path="/GetCustomer/UpdateCustomer/:id"
          element={
            <UpdateCustomer
              storeCustomer={storeCustomer}
              isLoading={customersLoading}
            />
          }
        />
        <Route
          path="/GetCustomer/Payment/:id"
          element={
            <Payment
              storeCustomer={storeCustomer}
              isLoading={customersLoading}
            />
          }
        />
        <Route
          path="/GetCustomer/IncreasePayment/:id"
          element={<IncreasePayment />}
        />
        <Route path="/TableOrder" element={<TableOrder />} />
        <Route path="/TableOrder/InfoOrder/:id" element={<InfoOrder />} />
        <Route
          path="/HomeShop"
          element={
            <HomeShop handleClick={handleClick} isLoading={productsLoading} />
          }
        />
        <Route path="/CartShop" element={<CartShop cart={cart} />} />
        <Route path="/Reports" element={<Reports />} />
        <Route path="/AddUnit" element={<AddUnit />} />
        <Route path="/GetUnit" element={<GetUnit />} />
        <Route
          path="/GetUnit/UpdateUnit/:id"
          element={
            <UpdateUnit storeUnits={storeUnits} isLoading={unitsLoading} />
          }
        />
        <Route path="/categories" element={<GetCategory />} />
        <Route path="/categories/add" element={<AddCategory />} />
        <Route path="/categories/update/:id" element={<UpdateCategory />} />
        <Route path="/NotFound" element={<NotFound />} />
        <Route
          path="/CategoryProductReport"
          element={<CategoryProductReport />}
        />
        <Route path="/GetCustomer/OrderHistory/:id" element={<CustomerOrderHistory />} />
        <Route path="/customer/:customerId/order/:orderId" element={<CustomerOrderDetail />} />
        <Route
          path="/GetCustomer/PaymentRecipt/:id/:paymentId"
          element={<PaymentRecipt />}
        />
        <Route
          path="/GetCustomer/PaymentRecipt/:id"
          element={<PaymentRecipt />}
        />
        <Route path="/edit-order/:id" element={<EditOrder />} />
        <Route path="/GetCustomer/CustomerPaymentHistory/:id" element={<CustomerPaymentHistory />} />
        <Route path="/GetCustomer/CombinedPayments/:id" element={<CombinedPayments />} />
      </Routes>
    </AppLayout>
  );
};

export default Home;
